module.exports = __webpack_public_path__ + "media/images/brand-assets/brand-a3ca6771725815667637e83406de5f51.png";